// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brand_on-promo .brand-list .brand-modal_item{width:23%!important}.brand_on-promo .time-period_item{cursor:pointer}.brand-suggested-brand-item_wrapper .brand-suggested-brand-item_banner-wrapper a{height:137px;display:block}", ""]);
// Exports
module.exports = exports;
